import store from '../store/store';
import { action, select } from 'satcheljs/lib/legacy';
export default select({
    messageAdListViewStatusStore: function () { return store; },
})(action('resetMessageAdListSelection')(function (state) {
    if (state && state.messageAdListViewStatusStore) {
        state.messageAdListViewStatusStore.selectedAdId = null;
    }
}));
//# sourceMappingURL=resetMessageAdListSelection.js.map